module.exports = __webpack_public_path__ + "img/salomon-maimon-s-theory-of-invention-cover.7df39936.jpg";